export default __webpack_public_path__ + "static/bb-logo-text-white-6bea11fd3d8e393e18ae36f36824ab73.svg";